/*
  garage-widget.js — "My Garage" header popover.
  Reads the saved vehicle from localStorage['axiom_garage'] (written by the
  vehicle search), shows it in a header popover, and lets the shopper jump to
  their fitment, change vehicle (scrolls to the search), or remove it.

  Shares the exact data model + URL logic with assets/vehicle-search.js:
    { year, make, model, trim, handle, prod, label }
    url = root + '/' + (prod ? 'products/' : 'collections/') + handle

  Stays in sync with the on-page search via the 'axiom:garage-change' event
  (same tab) and the native 'storage' event (other tabs).
  See docs/garage-widget.md.
*/
(function () {
  'use strict';

  var KEY = 'axiom_garage';

  function root() {
    var r = (((window.Shopify || {}).routes || {}).root) || '/';
    return r.replace(/\/$/, '');
  }
  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)); } catch (_) { return null; }
  }
  function destUrl(g) {
    return root() + '/' + (g.prod ? 'products/' : 'collections/') + g.handle;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  if (customElements.get('garage-widget')) return;

  customElements.define('garage-widget', class extends HTMLElement {
    connectedCallback() {
      this.toggleBtn = this.querySelector('[data-garage="toggle"]');
      this.panel = this.querySelector('[data-garage="panel"]');
      this.dot = this.querySelector('[data-garage="dot"]');
      if (!this.toggleBtn || !this.panel) return;
      this.isOpen = false;

      this.onDocClick = this.onDocClick.bind(this);
      this.onKey = this.onKey.bind(this);
      this.sync = this.sync.bind(this);

      this.toggleBtn.addEventListener('click', this.onToggle.bind(this));
      this.panel.addEventListener('click', this.onPanelClick.bind(this));
      window.addEventListener('storage', this.sync);
      window.addEventListener('axiom:garage-change', this.sync);

      this.sync();
    }

    sync() {
      var g = read();
      if (this.dot) this.dot.hidden = !(g && g.handle);
      if (this.isOpen) this.render(g);
    }

    render(g) {
      if (g && g.handle) {
        this.panel.innerHTML =
          '<div class="garage-widget__head">' +
            '<span class="garage-widget__kicker">Your Garage</span>' +
            '<button type="button" class="garage-widget__close" data-garage="close" aria-label="Close">&times;</button>' +
          '</div>' +
          '<p class="garage-widget__vehicle">' + esc(g.label) + '</p>' +
          '<a class="garage-widget__cta" href="' + esc(destUrl(g)) + '">Shop my vehicle</a>' +
          '<div class="garage-widget__links">' +
            '<button type="button" class="garage-widget__link" data-garage="change">Change vehicle</button>' +
            '<button type="button" class="garage-widget__link garage-widget__link--danger" data-garage="remove">Remove</button>' +
          '</div>';
      } else {
        this.panel.innerHTML =
          '<div class="garage-widget__head">' +
            '<span class="garage-widget__kicker">My Garage</span>' +
            '<button type="button" class="garage-widget__close" data-garage="close" aria-label="Close">&times;</button>' +
          '</div>' +
          '<p class="garage-widget__empty">No vehicle saved yet. Save yours to shop parts guaranteed to fit.</p>' +
          '<button type="button" class="garage-widget__cta" data-garage="find">Find your vehicle</button>';
      }
    }

    onToggle(e) {
      e.preventDefault();
      if (this.isOpen) this.close(); else this.open();
    }

    open() {
      this.render(read());
      this.panel.hidden = false;
      this.isOpen = true;
      this.toggleBtn.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', this.onDocClick, true);
      document.addEventListener('keydown', this.onKey);
      var first = this.panel.querySelector('a, button:not([data-garage="close"])');
      if (first) first.focus();
    }

    close() {
      this.panel.hidden = true;
      this.isOpen = false;
      this.toggleBtn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this.onDocClick, true);
      document.removeEventListener('keydown', this.onKey);
    }

    onDocClick(e) {
      if (!this.contains(e.target)) this.close();
    }

    onKey(e) {
      if (e.key === 'Escape') { this.close(); this.toggleBtn.focus(); }
    }

    onPanelClick(e) {
      var t = e.target.closest('[data-garage]');
      if (!t) return;
      var action = t.getAttribute('data-garage');
      if (action === 'close') {
        this.close();
        this.toggleBtn.focus();
      } else if (action === 'remove') {
        try { localStorage.removeItem(KEY); } catch (_) {}
        try { window.dispatchEvent(new CustomEvent('axiom:garage-change')); } catch (_) {}
        this.sync();
      } else if (action === 'change' || action === 'find') {
        this.close();
        this.goToSearch();
      }
    }

    goToSearch() {
      var el = document.querySelector('vehicle-search');
      if (!el) { window.location.href = root() + '/'; return; }
      // Bring the bar to just under the (sticky) header, then flash + focus it
      // so the action is obviously responsive even when it was already on screen.
      var y = el.getBoundingClientRect().top + (window.pageYOffset || 0) - 90;
      try { window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); }
      catch (_) { window.scrollTo(0, Math.max(0, y)); }
      el.classList.remove('vehicle-search--flash');
      // reflow so re-adding the class restarts the animation
      void el.offsetWidth;
      el.classList.add('vehicle-search--flash');
      setTimeout(function () { el.classList.remove('vehicle-search--flash'); }, 1400);
      var sel = el.querySelector('[data-vs="year"]');
      if (sel) {
        setTimeout(function () {
          try { sel.focus({ preventScroll: true }); } catch (_) { try { sel.focus(); } catch (e) {} }
        }, 500);
      }
    }
  });
})();
